module.exports = __webpack_public_path__ + "images/icons/icon-envelope-e67b631f.svg";